import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import imgNewsletter2540 from 'url:../../../../../resource/images/newsletter_2540.png';
import { nsNewsletter } from '@/app/i18n/namespaces';

// Sprint number : 2540
const Sp2540Newsletter300925 = ({ params }) => {
    const { t: translate } = useTranslation(nsNewsletter);

    return (
        <div className='space-y-4'>
            <div className='space-y-4'>
                <p className='font-semibold text-lg text-primary'>
                    {translate('editions.sp2540.title')}
                </p>
                <p>{translate('editions.sp2540.body')}</p>
            </div>
            <img onLoad={() => params.handleImageLoad()}
                src={imgNewsletter2540} /><br /><br />
        </div>
    );
};

Sp2540Newsletter300925.propTypes = {
    params: PropTypes.shape({
        handleImageLoad: PropTypes.func.isRequired
    }).isRequired
};

export default Sp2540Newsletter300925;
